import React, { useEffect, useState } from 'react';
import { Container, Table, Tab, Tabs, Alert, Form, Button,Pagination} from 'react-bootstrap';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../FireBase'; // Adjust the import path as needed
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import * as XLSX from 'xlsx'; // Import xlsx for Excel export
import { generateExcelReport } from '../components/reportUtils';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from '../components/Loading';



const CustomerList = () => {
    const [customers, setCustomers] = useState([]);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 20;

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                setLoading(true);
                const customersRef = collection(db, 'users'); // Adjust to your Firestore collection name
                const snapshot = await getDocs(customersRef);
                const customersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCustomers(customersData);
                console.log(customersData);
            } catch (err) {
                setError('Failed to fetch customers');
                console.error(err);
            }finally{
                setLoading(false);
            }
        };
      
        
        fetchCustomers();
    }, []);
    const formatAddress = (address) => {
        if (typeof address === 'object') {
            return `${address.address}, ${address.city}, ${address.state}, ${address.postalCode}, ${address.country}`;
        }
        return address;
    }

    // Filter customers based on the search query
    const filteredCustomers = customers.filter(customer =>
        (customer.name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
        (customer.phone?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
        (customer.cusmid?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    );
    
    const downloadReport = () => {
        setLoading(true);
        const customerSheet = {
            name: 'Customers',
            data: [
                ['Customer ID', 'Name', 'Email', 'Phone','Address'],
                ...customers.map(customer => [
                    customer.cusmid, 
                    customer.name,
                    customer.email, 
                    customer.phone,
                    formatAddress(customer.address)
                ])
            ]
        };

        generateExcelReport([customerSheet],'Customer_Report.xlsx');
        setLoading(false);
    };
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    if (loading) {
        // Render loading screen
        
        return (
          <div className="loading-screen">
            
          <Loading/>
          </div>
        );
      }
    return (
        <Container fluid className=' inventory-page'>
            <br />
            <div className='d-flex align-items-center'>
                <h1 className='flex-grow-1'>Customer List</h1>
                <Button variant="success" className='btn btn ml-auto' onClick={downloadReport}>
                    <FontAwesomeIcon icon={faFileExcel} className="fa-icon" /> Download Report
                </Button>
            </div>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form.Control
                type="text"
                placeholder="Search customers by username, id, phone..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="mb-3"
            />
         
            <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Phone</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map(customer => (
                                    <tr key={customer.cusmid}>
                                        <td>{customer.cusmid}</td>
                                        <td>
                                            <Link to={`/customerdetails/${customer.cusmid}`}>{customer.name}</Link>
                                        </td>
                                        <td>{customer.phone}</td>
                                       
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">No customers found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                                    <Pagination>
                                  {currentPage > 3 && (
                                      <>
                                      <Pagination.Item onClick={() => paginate(1)}>1</Pagination.Item>
                                      <Pagination.Ellipsis disabled />
                                      </>
                                  )}
                  
                                  {Array.from({ length: 5 }, (_, i) => {
                                      const page = currentPage - 2 + i;
                                      if (page > 0 && page <= totalPages) {
                                      return (
                                          <Pagination.Item
                                          key={page}
                                          active={page === currentPage}
                                          onClick={() => paginate(page)}
                                          >
                                          {page}
                                          </Pagination.Item>
                                      );
                                      }
                                      return null;
                                  })}
                  
                                  {currentPage < totalPages - 2 && (
                                      <>
                                      <Pagination.Ellipsis disabled />
                                      <Pagination.Item onClick={() => paginate(totalPages)}>{totalPages}</Pagination.Item>
                                      </>
                                  )}
                                  </Pagination>
        </Container>
    );
};

export default CustomerList;
